module.exports = __webpack_public_path__ + "static/img/8.a23600e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/8.jpg
// module id = CT13
// module chunks = 13